// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DirectMessageBaseClass } from './DirectMessageBase';
import { Message } from './Message';
export class DirectTradingSystemMessage extends DirectMessageBaseClass {
    constructor() {
        super(Message.CODE_TRADING_SYSTEM_MESSAGE);
        this.ImageBytes = null; // logo
        this.Login = null;
        this.Name = null;
        this.ID = null; // TradingSystemID
        this.CompanyName = null;
        this.RiskDisclosure = null;
    }
}
